<template>
  <div class='coursework-viewer__comment-panel_new-comment'>
    <div class='coursework-viewer__comment-panel_new-comment_textarea'>
      <redactor v-model="reply" type="short" placeholder="Leave a comment..." focus="true"/>
    </div>
    <div class='coursework-viewer__comment-panel_new-comment_btn mb1'>
      <a href="javascript:" class='kd-btn--sm btn--del' @click="cancel">Cancel</a>
      <a href="javascript:" class='kd-btn--sm btn--prim ladda-button' @click="persist">{{ persistLabel }} Comment</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: String
    },
    data() {
      return {
        replying: false,
        reply: null
      }
    },
    computed: {
      persistLabel() {
        return _.isEmpty(this.value) ? 'Post' : 'Save'
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel')
      },
      persist() {
        this.$emit('persist', this.reply)
      }
    },
    created() {
      this.reply = this.value
    }
  }
</script>